(() => {
  function initialize(root) {
    if (root.dataset.heroReady) return;
    root.dataset.heroReady = 'true';
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    const toggle = root.querySelector('[data-hero-pause]');
    const cta = root.querySelector('[data-hero-cta]');
    const stage = root.querySelector('.labs-hero__stage');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const signal = controller.signal;
    let index = 0;
    let inView = false;
    let paused = reduced.matches || Boolean(navigator.connection?.saveData) || root.dataset.autoplay !== 'true';
    let selectingUntil = 0;

    function update() {
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        slide.hidden = false;
        dots[i].setAttribute('aria-current', String(i === index));
        if (inView && !document.hidden && !paused) {
          if (!video.getAttribute('src')) video.src = video.dataset.src;
          video.muted = true;
          video.loop = true;
          video.play().catch(() => {});
        } else video.pause();
      });
      cta.dataset.studioModel = slides[index].dataset.model;
      cta.textContent = cta.dataset.studioModel === 'seedance-2.5' ? cta.dataset.seedance : cta.dataset.genjutsu;
    }

    function select(next) {
      index = (next + slides.length) % slides.length;
      selectingUntil = Date.now() + 900;
      stage.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: reduced.matches ? 'instant' : 'smooth'});
      update();
    }

    root.querySelector('[data-hero-prev]').addEventListener('click', () => select(index - 1), { signal });
    root.querySelector('[data-hero-next]').addEventListener('click', () => select(index + 1), { signal });
    dots.forEach((dot, i) => dot.addEventListener('click', () => select(i), { signal }));
    toggle.addEventListener('click', () => { paused = !paused; update(); }, { signal });
    document.addEventListener('visibilitychange', update, { signal });
    reduced.addEventListener('change', () => { if (reduced.matches) paused = true; update(); }, { signal });
    root.addEventListener('focusin', event => {
      if (event.target.matches(':focus-visible') && event.target !== toggle) { paused = true; update(); }
    }, { signal });
    root.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      paused = true;
      select(index + (event.key === 'ArrowRight' ? 1 : -1));
    }, { signal });
    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      update();
    }, { threshold: 0.2 });
    observer.observe(stage);
    let scrollTimer;
    stage.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (Date.now() < selectingUntil) return;
        const offset = stage.scrollLeft + slides[0].offsetLeft;
        index = stage.scrollLeft >= stage.scrollWidth - stage.clientWidth - 2 ? slides.length - 1 : slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - offset) < Math.abs(slides[best].offsetLeft - offset) ? i : best, 0);
        update();
      }, 120);
    }, {passive: true, signal});
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      observer.disconnect();
      controller.abort();
      slides.forEach(slide => slide.querySelector('video').pause());
    }, { once: true });
    update();
  }
  document.querySelectorAll('[data-labs-hero]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-labs-hero]').forEach(initialize);
  });
})();
